import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';
// frontend/src/components/chat/ChannelMuteMenu.jsx
// Menú de notificaciones por canal: todos | solo menciones | nada,
// y silenciar por tiempo (1h / 8h / 24h / hasta reactivar).
import React, { useState } from 'react';
import {
  Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography,
} from '@mui/material';
import {
  Notifications as BellIcon, NotificationsOff as BellOffIcon,
  AlternateEmail as AtIcon, NotificationsActive as BellAllIcon,
  Check as CheckIcon, Schedule as ClockIcon, NotificationsPaused as PausedIcon,
} from '@mui/icons-material';
import chatPrefs from '../../services/chatPrefs';
import { useNotification } from '../common/GlobalNotifications';

const ChannelMuteMenu = ({ channelId }) => {
  const { t } = useTranslation();
  const { showSuccess, showError } = useNotification();
  const [anchor, setAnchor] = useState(null);
  const setting = chatPrefs.getChannelSetting(channelId);
  const muted = chatPrefs.isChannelMuted(channelId);
  const mode = setting.mode || 'all';

  const apply = async (newMode, muteMinutes) => {
    setAnchor(null);
    try {
      await chatPrefs.setChannelNotification(channelId, newMode, muteMinutes);
      showSuccess(t('hardcoded.components_chat_channelmutemenu.preferencia_del_canal_guardada'));
    } catch (e) {
      showError(e?.response?.data?.detail || t('hardcoded.components_chat_channelmutemenu.no_se_pudo_guardar'));
    }
  };

  const mutedUntilLabel = setting.muted_until && new Date(setting.muted_until).getTime() > Date.now()
    ? t('hardcoded.components_chat_channelmutemenu.silenciado_hasta_newdatesettingm', { newDatesettingm: new Date(setting.muted_until).getFullYear() > 2070 ? t('hardcoded.components_chat_channelmutemenu.que_lo_reactives') : new Date(setting.muted_until).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) })
    : null;

  return (
    <>
      <Tooltip title={muted ? (mutedUntilLabel || t('hardcoded.components_chat_channelmutemenu.canal_silenciado')) : t('hardcoded.components_chat_channelmutemenu.notificaciones_del_canal')}>
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}
          color={muted ? 'warning' : 'default'}>
          {muted ? <BellOffIcon fontSize="small" /> : <BellIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        <Typography variant="caption" sx={{ px: 2, py: 0.5, display: 'block', color: 'text.secondary', fontWeight: 700 }}>
          {t('hardcoded.components_chat_channelmutemenu.notificar_en_este_canal')}</Typography>
        <MenuItem onClick={() => apply('all', 0)} selected={mode === 'all' && !muted}>
          <ListItemIcon><BellAllIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{t('hardcoded.components_chat_channelmutemenu.todos_los_mensajes')}</ListItemText>
          {mode === 'all' && !muted && <CheckIcon fontSize="small" color="primary" />}
        </MenuItem>
        <MenuItem onClick={() => apply('mentions', 0)} selected={mode === 'mentions'}>
          <ListItemIcon><AtIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{t('hardcoded.components_chat_channelmutemenu.solo_menciones')}</ListItemText>
          {mode === 'mentions' && <CheckIcon fontSize="small" color="primary" />}
        </MenuItem>
        <MenuItem onClick={() => apply('none', null)} selected={mode === 'none'}>
          <ListItemIcon><BellOffIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{t('hardcoded.components_chat_channelmutemenu.no_notificar')}</ListItemText>
          {mode === 'none' && <CheckIcon fontSize="small" color="primary" />}
        </MenuItem>
        <Divider />
        <Typography variant="caption" sx={{ px: 2, py: 0.5, display: 'block', color: 'text.secondary', fontWeight: 700 }}>
          {i18n.t('hardcoded.components_chat_channelmutemenu.silenciar_temporalmente')}</Typography>
        <MenuItem onClick={() => apply(mode, 60)}>
          <ListItemIcon><ClockIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{i18n.t('hardcoded.components_chat_channelmutemenu.1_hora')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => apply(mode, 480)}>
          <ListItemIcon><ClockIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{i18n.t('hardcoded.components_chat_channelmutemenu.8_horas')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => apply(mode, 1440)}>
          <ListItemIcon><ClockIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{i18n.t('hardcoded.components_chat_channelmutemenu.24_horas')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => apply(mode, -1)}>
          <ListItemIcon><PausedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{t('hardcoded.components_chat_channelmutemenu.hasta_que_lo_reactive')}</ListItemText>
        </MenuItem>
        {muted && (
          <>
            <Divider />
            <MenuItem onClick={() => apply(mode === 'none' ? 'all' : mode, 0)}>
              <ListItemIcon><BellIcon fontSize="small" color="success" /></ListItemIcon>
              <ListItemText>{t('hardcoded.components_chat_channelmutemenu.reactivar_notificaciones')}</ListItemText>
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};

export default ChannelMuteMenu;
